import type { WriteRejection } from "@estelle/domain";

/**
 * One line describing why a write was refused.
 *
 * Shared between the inline HSN editor and the bulk edit report so a
 * `conflict` reads the same way in both places. The switch has no `default`
 * on purpose — a sixth rejection kind added to the union in `@estelle/domain`
 * fails this file at compile time instead of silently describing it as
 * nothing.
 */
export function describeRejection(rejection: WriteRejection): string {
  switch (rejection.kind) {
    case "blocked":
    case "channel_rejected":
      return rejection.message;
    case "conflict":
      return `${rejection.message} It changed at ${rejection.currentUpdatedAt}.`;
    case "forbidden":
      return `${rejection.message} (requires ${rejection.permission})`;
    case "invalid":
      return rejection.fields
        ? `${rejection.message} ${Object.entries(rejection.fields)
            .map(([field, problem]) => `${field}: ${problem}`)
            .join("; ")}`
        : rejection.message;
  }
}
